/* src/app/components/pages/contacts/contacts.component.scss */
.material-icons.color_white {
  color: #ffffff;
}
.close-button {
  float: right;
  top: -24px;
  right: -24px;
}
.close-icon {
  transition: 1s ease-in-out;
}
.close-icon:hover {
  transform: rotate(180deg);
}
::ng-deep .contact-dialog .close-button {
  float: right;
  top: -52px;
  right: -52px;
}
::ng-deep .contact-dialog .mat-mdc-dialog-container {
  overflow: unset;
}
.captcha_box {
  width: 100%;
  display: block;
  float: left;
}
.captcha_answer {
  width: 35%;
  float: right;
}
input#answer {
  height: 43px;
  width: 100%;
  border: 2px solid #000;
  padding: 0 5px;
}
.captcha_code {
  height: 45px;
  width: 60%;
  float: left;
  background-size: cover;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  padding: 10px;
  line-height: 24px;
  text-align: center;
}
.captcha_code > span {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
}
.reload_captcha {
  width: 100%;
  float: left;
  padding: 10px 15px;
}
.captcha_code {
  background-image: url(/assets/images/captcha_bg.png);
}
.user_mob {
  font-size: 24px;
  line-height: 30px;
}
.heading {
  font-size: 23px;
  font-weight: 500;
  margin-bottom: 20px;
}
.ds_AboutMe {
  font-size: 16px;
  padding: 10px 0;
  color: #5e5e5e;
}
.mailaddress {
  font-size: 14px;
  color: #2196f3;
  text-decoration: none;
  font-weight: 400;
}
.color-f-s-23 {
  color: #5e5e5e;
  font-size: 23px;
  margin: 15px 0px;
}
.color-f-s-24 {
  color: #5e5e5e;
  font-size: 24px;
  margin: 9px 0px;
}
.color-f-s-19 {
  color: #5e5e5e;
  font-size: 19px;
}
.shop-btn {
  background: white;
  border-radius: 23px;
  display: inline-block;
  padding: 15px 32px;
  cursor: pointer;
}
.shop-btn:hover {
  background-color: #cccccc;
}
.product-button {
  margin: 20px;
  padding: 6px 32px !important;
  background-color: var(--theme-deafult-secondary) !important;
  color: white !important;
}
.product-button:hover {
  background-color: var(--theme-deafult-secondary) !important;
}
form mat-form-field {
  font-family: "IBM Plex Sans", sans-serif !important;
}
/*# sourceMappingURL=contacts.component.css.map */
